import React, { useState } from 'react';
import { connect } from 'react-redux';
import { InputText } from '../../../../../panda';
import { ChromePicker } from 'react-color';

import { IRootState } from '../../../../../modules/stores';

import { Container, ColorButton, PickerContainer, Mask } from './styled';

type IConnectProps = ReturnType<typeof mapState>;

interface IProps extends IConnectProps {
  name: string;
  setFn: (value: any) => void;
  step?: string;
  title?: string;
  type: string;
  value: string | number;
}

// Rough but not scalable implementation of colors.
const BaseInputColor = ({ name, setFn, step, title, type, value, locale }: IProps) => {
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);

  return (
    <Container>
      <ColorButton
        color={value as string}
        onClick={() => setIsColorPickerOpen(true)}
        hasTitle={!!title}
        locale={locale}
      ></ColorButton>
      <InputText
        input={{
          value,
          name,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
            e.preventDefault();
            setFn(e.target.value);
          },
        }}
        isSmall
        isReverse
        inputType={type}
        step={step}
        meta={{}}
        title={title}
      />
      {isColorPickerOpen && (
        <>
          <Mask onMouseDown={() => setIsColorPickerOpen(false)} />
          <PickerContainer hasTitle={!!title}>
            <ChromePicker
              color={value as string}
              disableAlpha={true}
              onChange={(value) => {
                setFn(value.hex);
              }}
            />
          </PickerContainer>
        </>
      )}
    </Container>
  );
};

const mapState = ({ core }: IRootState) => ({
  locale: core.locale,
});

export default connect(mapState)(BaseInputColor);
